// This modal box can be added to other things; will show form depending on personType, id.
// Will save and shut itself. And update redux store
// If a callback is given, will return id of saved or created customer

import * as React from 'react';
import { connect } from 'react-redux';
import PersonForm from '../../forms/personForm';
//import styles from './styles';

import { Container, Header, Content, Text, Label, Item, Input, Icon, Toast, Form, Spinner, View, Left, Right, Body, Button, Title } from 'native-base';
import { StyleSheet } from 'react-native';
import * as _ from 'lodash';
import Modal from '../../components/modal';
import Alert from '../../components/alert';
import CalCalDataApi from '../../api/CalCalDataApi';
import XDate from 'xdate';
import { formValueSelector, SubmissionError } from 'redux-form';
import diff from 'object-diff';

class PersonFormContainer extends React.Component {
	constructor(props) {
		super(props);

		this.initialState = {
			isLoading: true,
			isModalVisible: true,
			isSaving: false
		};
		this.state = this.initialState;
	}

	componentDidMount() {
		var details;
		if (this.props.id) {
			if (this.props.personType == 'customer') details = _.find(this.props.customers, { id: this.props.id });
			if (this.props.personType == 'supplier') details = _.find(this.props.suppliers, { id: this.props.id });
		} else {
			//New (personType)
			details = this.props.name ? { name: this.props.name } : {};
		}
		this.setState({ details });
	}

	//componentWillReceiveProps(nextProps) {}

	/*shouldComponentUpdate(nextProps, nextState){

	}*/

	async saveRecord() {
		this.setState({ isSaving: true });
		errors = await this.refs.form.submit();
		__DEV__ && console.log('errors', errors);
		this.setState({ isSaving: false });
		if (errors == undefined) this.props.closure(this.insertId);
	}
	handleSubmit(values) {
		//return {id:x, success: f/t, errors: {} }?
		delete values.undefined; //whatever!

		if (this.props.id) {
			__DEV__ && console.log('Edit customer', values, this.state.details);
			let difference = diff(this.state.details, values); //added, deleted, changed, updated (arrays)
			//console.log('diff:', difference);
			if (Object.keys(difference).length == 0) return this.props.closure() && false;

			difference.id = this.state.details.id; //send the id down to store!

			//console.log('SUBITTing', difference, values, this.state.details);
			return CalCalDataApi.dataUpdate(this.props.personType + 's/' + this.state.details.id, difference, this.props.jwt, res => {
				__DEV__ && console.log('handleSubmit ', res);
				if (res.success) {
					this.props.dispatch({
						type: 'UPDATE/customer', //successful update send UPDATE(d) to store
						id: this.state.details.id,
						difference //IF no JSON returned, trust local changes
					});
					this.props.closure();
					return false;
				} else if (res.validationErrors) {
					console.log('validationErrors ', res.validationErrors);
					throw new SubmissionError(res.validationErrors);
				} else {
					Alert.alert('Save failed: ' + (res.message || res.error));
					throw new SubmissionError(res.status);
				}
			});
		} else {
			//NEW
			__DEV__ && console.log('SUBITTing', values);
			if (Object.entries(values).length == 0) return;
			return CalCalDataApi.dataInsert(this.props.personType + 's', values, this.props.jwt, res => {
				//console.log('handleSubmit ', res);
				if (res.success) {
					this.insertId = res.id;
					this.props.dispatch({
						type: 'INSERT/' + this.props.personType, //successful update send UPDATE(d) to store
						values: res.record //{...values, id:res.id}						//HAS to include response for correct ID
					});
					this.props.closure(res.id);
					return false;
				} else if (res.validationErrors) {
					console.log('validationErrors ', res.validationErrors);
					throw new SubmissionError(res.validationErrors);
				} else {
					Alert.alert('Save failed: ' + (res.message || res.error));
					throw new SubmissionError(res.error);
				}
			});
		}
	}

	render() {
		if (this.state.isError) {
			return <Text style={{ color: 'red' }}>Error loading person!</Text>;
		} else {
			//closure here is cancel
			return (
				<Modal isOpen={this.state.isModalVisible} backButtonClose coverScreen swipeThreshold={100} style={styles.modalStyle} onClosed={() => this.props.closure()}>
					<PersonForm personType={this.props.personType} onSubmit={this.handleSubmit.bind(this)} initialValues={this.state.details} isNew={!this.props.id} toClose={this.props.closure} ref="form" />
				</Modal>
			);
		}
	}
}

const styles = StyleSheet.create({
	addPerson: {
		//color: '#438eb9',
		alignSelf: 'center'
		//marginLeft: 20
	},
	labelIcon: {
		color: '#2f6483',
		alignSelf: 'center',
		marginRight: 20
	},
	footer: {
		backgroundColor: '#F8F8F8'
	},
	modalStyle: {
		borderRadius: 10,
		alignItems: 'center',
		width: '90%',
		maxHeight: '90%'
	},
	modalContainer: {
		flex: 1,
		margin: 0,
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10,
		//justifyContent: 'center',
		backgroundColor: '#f8f8fc'
	},
	innerContainer: {
		flex: 1,
		margin: 0
		//alignItems: 'center',
	},
	modalHeader: {
		height: 45,
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10
	}
});

const mapStateToProps = state => ({
	customers: state.globalReducer.customers,
	suppliers: state.globalReducer.suppliers,
	jwt: state.loginReducer.jwt && state.loginReducer.jwt.token
});

export default connect(mapStateToProps)(PersonFormContainer);
